import { createAction, handleActions, combineActions } from 'redux-actions'
import { fromJS, Map } from 'immutable'
import { createSelector } from 'reselect'
import { normalize, schema } from 'normalizr'

// Schemas
const userEntity = new schema.Entity('users')

// Actions
export const fetchUsers = createAction('USERS_FETCH')
export const fetchUsersSuccess = createAction('USERS_FETCH_SUCCESS')
export const fetchUsersFail = createAction('USERS_FETCH_FAIL')

export const fetchUser = createAction('USER_FETCH')
export const fetchUserSuccess = createAction('USER_FETCH_SUCCESS')
export const fetchUserFail = createAction('USER_FETCH_FAIL')

export const createUser = createAction('USER_CREATE')
export const createUserFail = createAction('USER_CREATE_FAIL')

export const updateUser = createAction('USER_UPDATE')
export const updateUserFail = createAction('USER_UPDATE_FAIL')

export const deleteUser = createAction('USER_DELETE')
export const deleteUserSuccess = createAction('USER_DELETE_SUCCESS')
export const deleteUserFail = createAction('USER_DELETE_FAIL')

export const activateUser = createAction('USER_ACTIVATE');
export const forgotPassword = createAction('FORGOT_PASSWORD');
export const resetPassword = createAction('RESET_PASSWORD');

export const actions = {
  fetchUsers,
  fetchUsersSuccess,
  fetchUsersFail,
  fetchUser,
  fetchUserSuccess,
  fetchUserFail,
  createUser,
  createUserFail,
  updateUser,
  updateUserFail,
  deleteUser,
  deleteUserSuccess,
  deleteUserFail,
  activateUser,
  forgotPassword,
  resetPassword,
}

const defaultState = fromJS({
  data: {},
  isFetching: true,
  error: {}
})

export default handleActions({
  [fetchUsersSuccess]: (state, action) => {
    const normalizedData = normalize(action.payload, [userEntity])
    return state.mergeDeep({
      data: normalizedData.entities.users,
      isFetching: false
    })
  },

  [fetchUserSuccess]: (state, action) => {
    const normalizedData = normalize(action.payload, userEntity)
    return state.mergeDeep({
      data: normalizedData.entities.users,
      isFetching: false
    })
  },

  [deleteUserSuccess]: (state, action) => {
    return state.deleteIn(['data', action.payload.id])
  },

  [combineActions(
    fetchUsersFail,
    fetchUserFail,
    createUserFail,
    updateUserFail,
  )]: (state, action) => {
    return state.mergeDeep({
      error: action.payload,
      isFetching: false
    })
  }
}, defaultState)

// selectors
const usersSelector = state => state.user.get('data')
const isFetchingSelector = state => state.user.get('isFetching')

export const getUsers = createSelector(
  usersSelector,
  data => data.toArray().map(item => item.toJS())
)

export const getUser = (state, id) =>
  (usersSelector(state).get(String(id)) || new Map()).toJS()

export const isFetching = createSelector(
  isFetchingSelector,
  isFetching => isFetching
)



// WEBPACK FOOTER //
// ./src/store/userReducer.js